export enum SellingType {
  RETAIL = "retail",
  WHOLESALE = "wholesale",
}

export const SellingTypeInfo = {
  [SellingType.RETAIL]: { code: "retail", name: "Retail", icon: "retail" },
  [SellingType.WHOLESALE]: {
    code: "wholesale",
    name: "Wholesale",
    icon: "wholesale",
  },
} as const;

export const getSellingTypeCode = (value: SellingType): string =>
  SellingTypeInfo[value].code;
export const getSellingTypeName = (value: SellingType): string =>
  SellingTypeInfo[value].name;
export const getSellingTypeIcon = (value: SellingType): string =>
  SellingTypeInfo[value].icon;
